import { Injectable } from '@angular/core';
import { TokenService } from './token/token.service';
import { HttpHeaders } from '@angular/common/http';
import { ApiService } from '@app/gateway/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VerifyIdentityService {

  constructor(private token: TokenService, private apiService: ApiService) { }

  validateAddress(payload): Observable<any> {
    return this.apiService.post('users/address', payload, { headers: new HttpHeaders({ 'pageId': 'TCCVI', 'sessionId': this.token.getSessionId() }) }, true);
  }

  verifyIdentity(payload): Observable<any> {
    return this.apiService.post('indi/users/ridp', payload, { headers: new HttpHeaders({ 'pageId': 'TCCVI', 'sessionId': this.token.getSessionId() }) }, false);
  }

  getRidpRecord(payload): Observable<any> {
    return this.apiService.post('indi/users/ridpGetRecord', payload, { headers: new HttpHeaders({ 'pageId': 'TCCVI', 'sessionId': this.token.getSessionId() }) }, false);
  }

  investigateDocUpload(payload: any): Observable<any> {
    return this.apiService.post(`indi/users/ridp/investigateDocUpload`, payload, { headers: new HttpHeaders({ 'pageId': 'TCCVI', 'sessionId': this.token.getSessionId() }), }, false);
  }
}
